// store/slices/creditSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { creditService } from "../../services/credit.service";



export const fetchUserCredits = createAsyncThunk(
	"credits/fetchUserCredits",
	async (userId) => {
		const credits = await creditService.getUserCredits(userId);
		return credits;
	}
);

export const purchaseCredits = createAsyncThunk(
	"credits/purchaseCredits",
	async ({ userId, hours }) => {
		await creditService.purchaseCredits(userId, hours);
		return { purchasedHours: hours };
	}
);

export const validateBooking = createAsyncThunk(
	"credits/validateBooking",
	async ({ userId, requestedHours }) => {
		const validation = await creditService.validateBooking(
			userId,
			requestedHours
		);
		return validation;
	}
);

const creditSlice = createSlice({
	name: "credits",
	initialState: {
		availableCredits: 0,
		monthlyCredits: 0,
		rolloverCredits: 0,
		purchasedCredits: 0,
		nextRenewal: null,
		loading: false,
		error: null,
		validationResult: null,
	},
	reducers: {
		deductCredits: (state, action) => {
			state.availableCredits -= action.payload;
		},
		addCredits: (state, action) => {
			state.availableCredits += action.payload;
			state.purchasedCredits += action.payload;
		},
		resetValidation: (state) => {
			state.validationResult = null;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchUserCredits.pending, (state) => {
				state.loading = true;
			})
			.addCase(fetchUserCredits.fulfilled, (state, action) => {
				state.loading = false;
				Object.assign(state, action.payload);
				state.error = null;
			})
			.addCase(fetchUserCredits.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message;
			})
			.addCase(purchaseCredits.fulfilled, (state, action) => {
				state.availableCredits += action.payload.purchasedHours;
				state.purchasedCredits += action.payload.purchasedHours;
			})
			.addCase(validateBooking.fulfilled, (state, action) => {
				state.validationResult = action.payload;
			});
	},
});

export const { deductCredits, addCredits, resetValidation } =
	creditSlice.actions;

export default creditSlice.reducer;

// Selectors
export const selectCredits = (state) => ({
	available: state.credits.availableCredits,
	monthly: state.credits.monthlyCredits,
	rollover: state.credits.rolloverCredits,
	purchased: state.credits.purchasedCredits,
	nextRenewal: state.credits.nextRenewal,
});

export const selectCreditLoading = (state) => state.credits.loading;
export const selectValidationResult = (state) => state.credits.validationResult;
